export const FETCH_NBR_LIST = 'FETCH_NBR_LIST';

